import { Link } from 'react-router-dom';

type ConnectStripeRequiredProps = {
  title: string;
  description: string;
};

export default function ConnectStripeRequired({
  title,
  description,
}: ConnectStripeRequiredProps) {
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6">
      <h3 className="text-lg font-medium text-blue-800 dark:text-blue-200 mb-2">
        {title}
      </h3>
      <p className="text-sm text-blue-700 dark:text-blue-300 mb-4">{description}</p>
      <Link
        to="/app/settings/integrations"
        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        Connect Stripe Account
      </Link>
    </div>
  );
}
